import { render, staticRenderFns } from "./ListEmpty.vue?vue&type=template&id=0cf8c62d&scoped=true&"
import script from "./ListEmpty.vue?vue&type=script&lang=js&"
export * from "./ListEmpty.vue?vue&type=script&lang=js&"
import style0 from "./ListEmpty.vue?vue&type=style&index=0&id=0cf8c62d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf8c62d",
  null
  
)

export default component.exports